import * as React from "react";
import { forwardRef } from "react";
const SvgWClose = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "x-close" }, /* @__PURE__ */ React.createElement("path", { id: "Icon", d: "M15 5L5 15M5 5L15 15", stroke: "#F5F2FF", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })));
const ForwardRef = forwardRef(SvgWClose);
export default ForwardRef;
